<div
  class="image-view"
  [class.image-view--auto-fit]="fit === 'auto'"
  role="button"
  tabindex="0"
  aria-label="Click to expand image"
  matTooltip="Expand"
  (click)="handleFullscreen($event)"
  (keyup.enter)="handleFullscreen($event)"
  #imageView>
  <!-- image -->
  <img
    class="image-view__image"
    [src]="src"
    [alt]="alt"
    [style.max-width]="fit === 'auto' && fitSize ? fitSize + 'px' : '100%'"
    [style.max-height]="fit === 'auto' && fitSize ? fitSize + 'px' : '100%'" />

  <div class="image-view__overlay">
    <app-icon icon="expand-alt" class="image-view__icon"></app-icon>
  </div>
</div>
